import script from "./AlertContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertContainer.vue?vue&type=script&setup=true&lang=js"

import "./AlertContainer.vue?vue&type=style&index=0&id=21da5abe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21da5abe"]])

export default __exports__